<template>
  <footer class="footer-mobile" v-if="isMobile">
    <Text
      title="Copyright © Tayori .inc"
      color="#8A8A8A"
      fontSize="1.4rem"
      fontWeight="400"
      lineHeight="2.4rem"
    />
  </footer>
</template>

<script lang="ts">
import { defineComponent, inject } from 'vue';
import Text from '@/components/Text/index.vue';

export default defineComponent({
  name: 'Footer',
  components: { Text },
  props: {
    msg: String
  },
  setup() {
    const isMobile: any = inject('isMobile');

    return {
      isMobile
    };
  }
});
</script>

<style scoped lang="scss">
.footer-mobile {
  background: #101010;
  width: 100%;
  .text {
    text-align: center;
    padding: 1.6rem 0;
  }
}
</style>
